module.exports = __webpack_public_path__ + "media/search/hospitality_grayscale-8be608d9.png";